/* ==========================================================================
   ASURA — Directorio de marcas (snippets/asura-marcas.liquid)

   Un solo buscador para todas las casas: filtra mientras se escribe (sin
   importar acentos, mayúsculas ni espacios), apaga las letras sin marcas y
   salta a la letra que se toque. Enter abre la primera marca que coincide;
   Esc borra la búsqueda o cierra el menú.
   En escritorio el panel se acomoda debajo de "Marcas" sin salirse de la
   pantalla y no se cierra mientras se escribe en el buscador.
   ========================================================================== */
(function () {
  'use strict';

  if (window.asuraMarcas) return;
  window.asuraMarcas = true;

  function normal(texto) {
    return (texto || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function iniciar(caja) {
    if (caja.dataset.listo) return;
    caja.dataset.listo = '1';

    var modo = caja.dataset.modo;
    var campo = caja.querySelector('[data-asura-marcas-buscar]');
    var lista = caja.querySelector('[data-asura-marcas-lista]');
    var vacio = caja.querySelector('[data-asura-marcas-vacio]');
    var consulta = caja.querySelector('[data-asura-marcas-consulta]');
    var enlaceVacio = vacio ? vacio.querySelector('a') : null;
    var marcas = Array.prototype.slice.call(caja.querySelectorAll('[data-marca]'));
    var grupos = Array.prototype.slice.call(caja.querySelectorAll('[data-grupo]'));
    var saltos = Array.prototype.slice.call(caja.querySelectorAll('[data-letra]'));

    marcas.forEach(function (m) {
      var n = normal(m.dataset.marca);
      m._buscar = n + ' ' + n.replace(/ /g, '');
    });

    var bloqueo = 0;

    function grupo(letra) {
      return caja.querySelector('[data-grupo="' + letra + '"]');
    }

    function filtrar() {
      var q = normal(campo.value);
      var junto = q.replace(/ /g, '');
      var hay = 0;

      marcas.forEach(function (m) {
        var si = !q || m._buscar.indexOf(q) !== -1 || m._buscar.indexOf(junto) !== -1;
        m.hidden = !si;
        if (si) hay++;
      });
      grupos.forEach(function (g) {
        g.hidden = !g.querySelector('[data-marca]:not([hidden])');
      });
      saltos.forEach(function (b) {
        var g = grupo(b.dataset.letra);
        b.disabled = !g || g.hidden;
      });

      caja.classList.toggle('is-buscando', !!q);
      if (vacio) {
        vacio.hidden = hay > 0;
        if (!hay) {
          var texto = campo.value.trim();
          consulta.textContent = texto;
          enlaceVacio.href = enlaceVacio.getAttribute('href').split('?')[0] +
            '?q=' + encodeURIComponent(texto) + '&options%5Bprefix%5D=last';
        }
      }
      if (lista && modo !== 'pagina') lista.scrollTop = 0;
    }

    function irA(letra) {
      var g = grupo(letra);
      if (!g || g.hidden) return;

      if (modo === 'pagina') {
        // la letra tocada queda marcada mientras la página se desliza hasta ella
        bloqueo = Date.now() + 1200;
        saltos.forEach(function (s) { s.classList.toggle('is-activa', s.dataset.letra === letra); });
        var barra = caja.querySelector('.asura-marcas__barra');
        var alto = barra ? barra.getBoundingClientRect().height : 0;
        var y = g.getBoundingClientRect().top + window.pageYOffset - alto - 24;
        window.scrollTo({ top: y, behavior: 'smooth' });
      } else if (lista.scrollHeight > lista.clientHeight + 2) {
        lista.scrollTo({ top: g.offsetTop - 6, behavior: 'smooth' });
      }

      g.classList.remove('is-senalado');
      void g.offsetWidth;
      g.classList.add('is-senalado');
      setTimeout(function () { g.classList.remove('is-senalado'); }, 1400);
    }

    campo.addEventListener('input', filtrar);
    campo.addEventListener('search', filtrar);

    campo.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var primera = caja.querySelector('[data-marca]:not([hidden]) a');
        if (primera) {
          window.location.href = primera.href;
        } else if (campo.value.trim() && enlaceVacio) {
          window.location.href = enlaceVacio.href;
        }
      } else if (e.key === 'Escape') {
        if (campo.value) {
          e.stopPropagation();
          campo.value = '';
          filtrar();
        } else {
          var detalles = caja.closest('details');
          if (detalles) {
            // sin enfocar "Marcas": el tema vuelve a abrir el menú al recibir foco
            campo.blur();
            detalles.removeAttribute('open');
          }
        }
      }
    });

    saltos.forEach(function (b) {
      b.addEventListener('click', function () { irA(b.dataset.letra); });
    });

    // Página: la letra de la sección que se está leyendo queda marcada
    if (modo === 'pagina' && 'IntersectionObserver' in window) {
      var visibles = {};
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          visibles[en.target.dataset.grupo] = en.isIntersecting;
        });
        if (Date.now() < bloqueo) return;
        var actual = null;
        grupos.some(function (g) {
          if (visibles[g.dataset.grupo] && !g.hidden) {
            actual = g.dataset.grupo;
            return true;
          }
          return false;
        });
        saltos.forEach(function (b) {
          b.classList.toggle('is-activa', b.dataset.letra === actual);
        });
      }, { rootMargin: '-140px 0px -45% 0px' });
      grupos.forEach(function (g) { observador.observe(g); });
    }

    // Página: la barra del buscador marca su línea cuando ya va fija arriba
    if (modo === 'pagina') {
      var barraFija = caja.querySelector('.asura-marcas__barra');
      var revisar = function () {
        barraFija.classList.toggle('is-fija', barraFija.getBoundingClientRect().top <= 0.5 && window.pageYOffset > 0);
      };
      window.addEventListener('scroll', revisar, { passive: true });
      revisar();
    }
  }

  /* Escritorio: el panel debajo de "Marcas", dentro de la pantalla */
  function colocar(detalles) {
    var panel = detalles.querySelector('.asura-marcas-panel');
    var item = detalles.closest('.site-nav__item');
    if (!panel || !item) return;
    var ancho = panel.offsetWidth;
    var vw = document.documentElement.clientWidth;
    var r = item.getBoundingClientRect();
    var margen = 24;
    var izquierda = r.left + r.width / 2 - ancho / 2;
    izquierda = Math.max(margen, Math.min(izquierda, vw - ancho - margen));
    panel.style.left = Math.round(izquierda - r.left) + 'px';
  }

  function prepararMenu(detalles) {
    if (detalles.dataset.asuraListo) return;
    detalles.dataset.asuraListo = '1';
    var campo = detalles.querySelector('[data-asura-marcas-buscar]');

    colocar(detalles);
    detalles.addEventListener('toggle', function () {
      if (detalles.open) colocar(detalles);
    });
    window.addEventListener('resize', function () { colocar(detalles); });

    // el tema cierra el menú al sacar el mouse; si se está escribiendo, sigue abierto
    detalles.addEventListener('mouseleave', function () {
      if (campo && document.activeElement === campo) {
        detalles.setAttribute('open', '');
      }
    });
  }

  function arrancar() {
    document.querySelectorAll('[data-asura-marcas]').forEach(iniciar);
    document.querySelectorAll('.asura-nav-marcas details').forEach(prepararMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
